import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

/**
 * The new messaging story: copy on the left, a portal thread plus the phone
 * overlapping it on the right — same rhythm as the apps section.
 */
const Messaging: React.FC = () => {
  const { locale, t } = useLocale()
  const points = t('messaging.points') as string[]

  return (
    <section
      id="berichten"
      className="border-y border-border bg-surface-card px-5 py-16 sm:px-8 lg:px-14 lg:py-[88px]"
    >
      <div className="mx-auto grid max-w-[1280px] items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="inline-flex items-center rounded-pill bg-clay-100 px-3 py-1 text-[13px] font-semibold text-clay-700">
            {t('messaging.eyebrow')}
          </span>
          <h2 className="mt-4 text-balance font-display text-[30px] font-bold tracking-display sm:text-[38px]">
            {t('messaging.title')}
          </h2>
          <p className="mt-4 max-w-[48ch] text-[17px] leading-relaxed text-text-secondary">
            {t('messaging.body')}
          </p>

          <ul className="mt-6 flex flex-col gap-2.5 text-[15px] text-text-primary">
            {points.map((point) => (
              <li key={point} className="flex gap-2.5">
                <span aria-hidden className="font-bold text-status-success">
                  ✓
                </span>
                {point}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative mx-auto w-full max-w-[560px] pb-8 sm:pb-16">
          <div className="overflow-hidden rounded-xl border border-border bg-surface-page shadow-raised">
            <img
              src={`/img/messages-portal-${locale}.png`}
              alt={t('messaging.portalAlt')}
              width={1440}
              height={900}
              loading="lazy"
              className="block h-auto w-full"
            />
          </div>
          <div className="mx-auto mt-6 w-[200px] rounded-[36px] bg-neutral-900 p-2 shadow-raised sm:absolute sm:-bottom-8 sm:right-0 sm:mt-0 sm:w-[220px]">
            <img
              src={`/img/messages-app-${locale}.jpg`}
              alt={t('messaging.appAlt')}
              width={600}
              height={1303}
              loading="lazy"
              className="block h-auto w-full rounded-[28px]"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Messaging
